import { BONUSX_SUBSCRIPTION_TIERS } from "../../services/user-subscription/enums/bonusx-subscription-tiers.enum";

export const BONUSX_SUBSCRIPTION_TIERS_VALUES = Object.values(BONUSX_SUBSCRIPTION_TIERS);

export function isSubscriptionTierLowerThanRequested(
  subscriptionTier: BONUSX_SUBSCRIPTION_TIERS,
  requestedTier: BONUSX_SUBSCRIPTION_TIERS
): boolean {
  const subscriptionTierIndexInEnum = subscriptionTierPositionInEnum(subscriptionTier);
  const requestedTierIndexInEnum = subscriptionTierPositionInEnum(requestedTier);

  return subscriptionTierIndexInEnum < requestedTierIndexInEnum;
}

export function subscriptionTierPositionInEnum(tier: BONUSX_SUBSCRIPTION_TIERS): number {
  return BONUSX_SUBSCRIPTION_TIERS_VALUES.indexOf(tier);
}
